import { useSubscription } from '@apollo/client';
import { GET_SUBMISSIONS_EVENTS } from '../api-hooks/submissions.subscription';
export function useStatusesSubscription() {
  const { loading, error, data } = useSubscription(GET_SUBMISSIONS_EVENTS);

  const updateStatus =
    data?.events.__typename === 'SubscriptionEventModel'
      ? data?.events.eventNotice
      : undefined;

  return {
    updateStatus,
    loading,
    error,
    data,
  };
}
